import PropTypes from 'prop-types'
import React from 'react'
import { AutoComplete } from 'material-ui'
import styles from './styles/bookingAutoComplete.css'

class BookingAutoComplete extends React.Component {
  state = {
    touched: false
  }

  handleUpdateInput = (inputTime) => {
    const { labelText, autoCompleteOnChange } = this.props
    const startOrEnd = labelText.split(' -')[0]
    const timeOptionMatch = this.findMatchInTimeOptions(inputTime)
    if (timeOptionMatch) {
      autoCompleteOnChange(startOrEnd, timeOptionMatch.value)
      this.setState({
        touched: false,
      })
    } else {
      this.setState({
        touched: true,
      })
    }
  }

  handleMenuSelect = (selectedTimeOption, selectedTimeOptionIndex) => {
    const { labelText, autoCompleteOnChange } = this.props
    const startOrEnd = labelText.split(' -')[0]
    if (selectedTimeOptionIndex !== -1) {
      autoCompleteOnChange(startOrEnd, selectedTimeOption.value)
      this.setState({
        touched: false
      })
    }
  }

  findMatchInTimeOptions = inputTime => (
    this.props.dataSource.find(timeOption => timeOption.text === inputTime)
  )

  filter = (inputTime, timeOptionText) => inputTime !== '' && timeOptionText.indexOf(inputTime) === 0

  render() {
    const {
      labelText,
      hintText,
      dataSource,
    } = this.props
    const {
      touched,
    } = this.state
    return (
      <AutoComplete
        errorText={touched ? 'Entry must match a time option in dropdown' : ''}
        hintText={hintText}
        className={styles.autoCompleteField}
        floatingLabelText={labelText}
        openOnFocus={true}
        onUpdateInput={this.handleUpdateInput}
        onNewRequest={this.handleMenuSelect}
        dataSource={dataSource}
        filter={this.filter}
        menuProps={{ maxHeight: 200 }}
        style={{ flex: 1, margin: '6px' }}
        textFieldStyle={{ width: '100%' }}
      />
    )
  }
}

BookingAutoComplete.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelText: PropTypes.string.isRequired,
  hintText: PropTypes.string,
  autoCompleteOnChange: PropTypes.func.isRequired,
}

export default BookingAutoComplete



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingsCalendar/BookingPopover/BookingAutoComplete.js